import z from "zod";

import type { AttendanceTypeV2 } from "@lib/api/getAttendancesV2";
import {
    api_pkg_attendance_dto_StatusSchema,
    api_pkg_attendance_dto_TypeSchema,
} from "@sdk/schemas";

export const AttendanceStatusEnum = api_pkg_attendance_dto_StatusSchema.enum;

export const AttendanceTypeEnum = api_pkg_attendance_dto_TypeSchema.enum;
export type AttendanceTypeUnion = AttendanceTypeV2;

export function isAttendanceTypeEnum(type: string): type is AttendanceTypeUnion {
    return Object.values(AttendanceTypeEnum).includes(type as AttendanceTypeUnion);
}

export const TimesheetsDateModeEnum = z.enum(["all", "day", "week", "month"]);
export type TimesheetsDateModeUnion =
    (typeof TimesheetsDateModeEnum)[keyof typeof TimesheetsDateModeEnum];

export const TimesheetsSearchModeEnum = z.enum(["sider", "manager"]);
export type TimesheetsSearchModeUnion =
    (typeof TimesheetsSearchModeEnum)[keyof typeof TimesheetsSearchModeEnum];

export type AttendanceDateModeUnion = TimesheetsDateModeUnion | "rolling";

/** Literal date modes, shared by the Timesheets and NetworkAttendances filters. */
export type AttendanceDateMode = z.infer<typeof TimesheetsDateModeEnum> | "rolling";
/** Literal search modes, shared by the Timesheets and NetworkAttendances filters. */
export type AttendanceSearchMode = z.infer<typeof TimesheetsSearchModeEnum>;
